'use strict';

var _toConsumableArray = require("/Users/edtsech/code/projects/duonote/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var adaptor_1 = require('../adaptor');

var ref_1 = require('../ref');
/**
 * Converts Typesaurus data to Firestore format. It deeply traverse all the data and
 * converts values to compatible format.
 *
 * @param data - the data to convert
 */


function unwrapData(data) {
  var _adaptor_1$FirestoreF, _adaptor_1$FirestoreF2;

  if (data instanceof Date) {
    return adaptor_1.FirestoreTimestamp.fromDate(data);
  } else if (data && typeof data === 'object') {
    if (data.__type__ === 'ref') {
      return ref_1.refToFirestoreDocument(data);
    } else if (data.__type__ === 'value') {
      var fieldValue = data;

      switch (fieldValue.kind) {
        case 'remove':
          return adaptor_1.FirestoreFieldValue.delete();

        case 'increment':
          return adaptor_1.FirestoreFieldValue.increment(fieldValue.number);

        case 'arrayUnion':
          return (_adaptor_1$FirestoreF = adaptor_1.FirestoreFieldValue).arrayUnion.apply(_adaptor_1$FirestoreF, _toConsumableArray(fieldValue.values));

        case 'arrayRemove':
          return (_adaptor_1$FirestoreF2 = adaptor_1.FirestoreFieldValue).arrayRemove.apply(_adaptor_1$FirestoreF2, _toConsumableArray(fieldValue.values));

        case 'serverDate':
          return adaptor_1.FirestoreFieldValue.serverTimestamp();
      }
    }

    var unwrappedObject = Object.assign(Array.isArray(data) ? [] : {}, data);
    Object.keys(unwrappedObject).forEach(function (key) {
      unwrappedObject[key] = unwrapData(unwrappedObject[key]);
    });
    return unwrappedObject;
  } else if (data === undefined) {
    return null;
  } else {
    return data;
  }
}

exports.unwrapData = unwrapData;
/**
 * Converts Firestore data to Typesaurus format. It deeply traverse all the
 * data and converts values to compatible format.
 *
 * @param data - the data to convert
 */

function wrapData(data) {
  if (data instanceof adaptor_1.FirestoreDocumentReference) {
    return ref_1.pathToRef(data.path);
  } else if (data instanceof adaptor_1.FirestoreTimestamp) {
    return data.toDate();
  } else if (data && typeof data === 'object') {
    var wrappedData = Object.assign(Array.isArray(data) ? [] : {}, data);
    Object.keys(wrappedData).forEach(function (key) {
      wrappedData[key] = wrapData(wrappedData[key]);
    });
    return wrappedData;
  } else {
    return data;
  }
}

exports.wrapData = wrapData;